<hpf-credit-form
        *ngIf="credit"
        [credit]="credit"
        (create)="onCreate($event)"
    ></hpf-credit-form>
<div *ngIf="!credit" class="my-5 text-center">
    <nz-spin nzSimple></nz-spin>
</div>